import React from 'react';

const BARejectDriverIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.66406 17.5C1.66406 16.3401 1.9667 15.2002 2.54209 14.193C3.11747 13.1858 3.94568 12.3462 4.94489 11.7571C5.9441 11.168 7.07972 10.8498 8.23955 10.8339C9.39938 10.8181 10.5433 11.1051 11.5582 11.6667M14.1641 14.1667L18.3307 18.3333M18.3307 14.1667L14.1641 18.3333M12.4974 6.66667C12.4974 8.96785 10.6319 10.8333 8.33073 10.8333C6.02954 10.8333 4.16406 8.96785 4.16406 6.66667C4.16406 4.36548 6.02954 2.5 8.33073 2.5C10.6319 2.5 12.4974 4.36548 12.4974 6.66667Z'
        stroke='#FF0500'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default BARejectDriverIcon;
